.jv{pointer-events:auto;}